export default "__VITE_ASSET__314a3b50__"